// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-screens-Organization-Show-Center-_m6908"};